import type { RouteObject } from 'react-router';

// Wrapper & Auth
import CasesWrapper from './layout/casesWrapper';
import GlobalAuthProvider from '@@/contexts/GlobalAuthProvider';

// Authorizer to check user permissions for cases module
import CasesAuthorizer from './components/CasesAuthorizer';

// Role-Based Page Component to display the appropriate page based on user permissions
import RoleBasedPage from './components/role-based-access/RoleBasedPage';
import { pagePermissionMapping } from './common/page-permission-mapping';

// Route paths
export const CASES_ROUTES = {
  CASES: '/portal/cx-cases/cases',
  CASE_DETAIL: {
    PATH: '/portal/cx-cases/cases/:caseId/detail',
    buildPath: (caseId: string) => `/portal/cx-cases/cases/${caseId}/detail`
  },
  CREATE_CASE: '/portal/cx-cases/cases/create',
  EDIT_CASE: {
    PATH: '/portal/cx-cases/cases/:caseId/edit',
    buildPath: (caseId: string) => `/portal/cx-cases/cases/${caseId}/edit`
  },
  TEMPLATES: {
    LIST: '/portal/cx-cases/templates',
    DETAIL: {
      PATH: '/portal/cx-cases/templates/:templateId',
      buildPath: (templateId: string) => `/portal/cx-cases/templates/${templateId}`
    },
    CREATE: '/portal/cx-cases/templates/create',
    EDIT: {
      PATH: '/portal/cx-cases/templates/:templateId/edit',
      buildPath: (templateId: string) => `/portal/cx-cases/templates/${templateId}/edit`
    }
  },
  CONTACTS_MANAGEMENT: {
    LIST: '/portal/cx-cases/contacts-management',
    PROFILES: {
      LIST: '/portal/cx-cases/contacts-management/profiles',
      DETAIL: {
        PATH: '/portal/cx-cases/contacts-management/profiles/:profileId/detail',
        buildPath: (profileId: string) => `/portal/cx-cases/contacts-management/profiles/${profileId}/detail`
      },
      CREATE: '/portal/cx-cases/contacts-management/profiles/create',
      EDIT: {
        PATH: '/portal/cx-cases/contacts-management/profiles/:profileId/edit',
        buildPath: (profileId: string) => `/portal/cx-cases/contacts-management/profiles/${profileId}/edit`
      }
    },
    COMPANIES: {
      DETAIL: {
        PATH: '/portal/cx-cases/contacts-management/companies/:companyId/detail',
        buildPath: (companyId: string) => `/portal/cx-cases/contacts-management/companies/${companyId}/detail`
      }
    }
  }
};

const cxCasesRoutes: RouteObject[] = [
  {
    path: 'portal',
    element: <GlobalAuthProvider />,
    children: [
      {
        element: <CasesAuthorizer />,
        children: [
          {
            element: <CasesWrapper />,
            children: [
              {
                path: CASES_ROUTES.CASES,
                element: <RoleBasedPage config={pagePermissionMapping.ALL_CASES} />
              },
              {
                path: CASES_ROUTES.CASE_DETAIL.PATH,
                element: <RoleBasedPage config={pagePermissionMapping.CASE_DETAIL} />
              },
              {
                path: CASES_ROUTES.CREATE_CASE,
                element: <RoleBasedPage config={pagePermissionMapping.CASE_CREATE_UPDATE} />
              },
              {
                path: CASES_ROUTES.EDIT_CASE.PATH,
                element: <RoleBasedPage config={pagePermissionMapping.CASE_CREATE_UPDATE} />
              },
              {
                path: CASES_ROUTES.TEMPLATES.LIST,
                element: <RoleBasedPage config={pagePermissionMapping.TEMPLATES_LIST} />
              },
              {
                path: CASES_ROUTES.TEMPLATES.CREATE,
                element: <RoleBasedPage config={pagePermissionMapping.TEMPLATE_CREATE_UPDATE} />
              },
              {
                path: CASES_ROUTES.TEMPLATES.EDIT.PATH,
                element: <RoleBasedPage config={pagePermissionMapping.TEMPLATE_CREATE_UPDATE} />
              },
              {
                path: CASES_ROUTES.CONTACTS_MANAGEMENT.LIST,
                element: <RoleBasedPage config={pagePermissionMapping.CONTACTS_MANAGEMENT} />
              },
              {
                path: CASES_ROUTES.CONTACTS_MANAGEMENT.PROFILES.DETAIL.PATH,
                element: <RoleBasedPage config={pagePermissionMapping.PROFILE_DETAIL} />
              },
              {
                path: CASES_ROUTES.CONTACTS_MANAGEMENT.PROFILES.CREATE,
                element: <RoleBasedPage config={pagePermissionMapping.PROFILE_CREATE_UPDATE} />
              },
              {
                path: CASES_ROUTES.CONTACTS_MANAGEMENT.PROFILES.EDIT.PATH,
                element: <RoleBasedPage config={pagePermissionMapping.PROFILE_CREATE_UPDATE} />
              },
              {
                path: CASES_ROUTES.CONTACTS_MANAGEMENT.COMPANIES.DETAIL.PATH,
                element: <RoleBasedPage config={pagePermissionMapping.COMPANY_DETAIL} />
              }
            ]
          }
        ]
      }
    ]
  }
];

export default cxCasesRoutes;
